const API = {
  TOKEN: {
    ACCESS: `api/token/`,
    REFRESH: `api/token/refresh/`
  },
  ROLES: {
    INDEX: `roles/`
  },
  CORE: {
    PROJECTS: {
      INDEX: `projects/`,
      SPENDING: (id: number) => `projects/${id}/spending/`,
      SPENDING_CAP: (id: number) => `projects/${id}/spending_cap/`
    },
    PROJECT_USERS: {
      INDEX: `project_users/`
    },
    USERS: {
      INDEX: `users/`,
      CURRENT_USER: `users/current_user/`
    },
    CALCULATIONS: {
      INDEX: `calculations/`,
      CONTAINER_IMAGES: `calculations/container_images/`,
      CELERY_CALCULATE: (id: number) => `calculations/${id}/celery_calculate/`,
      RESCHEDULE: (id: number) => `calculations/${id}/reschedule/`,
      STOP: (id: number) => `calculations/${id}/stop/`,
      GET_COMPUTE_RESOURCES: (id: number) => `calculations/${id}/get_compute_resources/`,
      GET_HISTORICAL_COMPUTE_RESOURCES: (id: number) =>
        `calculations/${id}/get_historical_compute_resources/`,
      GET_RESULT_FILES: (id: number) => `calculations/${id}/get_result_files/`,
      GET_COMPUTE_RESOURCE_LOGS: (id: number, computeResourceName: string, tail = 500) => {
        const params = new URLSearchParams({
          compute_resource_name: computeResourceName,
          tail: tail.toString()
        })
        return `calculations/${id}/get_compute_resource_logs/?${params.toString()}`
      },
      DOWNLOAD_COMPUTE_RESOURCE_LOGS: (id: number, computeResourceName: string) => {
        const params = new URLSearchParams({
          compute_resource_name: computeResourceName
        })
        return `calculations/${id}/download_compute_resource_logs/?${params.toString()}`
      },
      DOWNLOAD_RESULT_FILE: (id: number, blobName: string) =>
        `calculations/${id}/download_result_file/?blob_name=${encodeURIComponent(blobName)}`,
      DELETE_RESULT_FILE: (id: number, blobName: string) =>
        `calculations/${id}/delete_result_file/?blob_name=${encodeURIComponent(blobName)}`,
      DOWNLOAD_RESULT_FILES_ZIP: (id: number, path = '') => {
        const params = new URLSearchParams()
        if (path) params.set('path', path)
        const query = params.toString()
        return `calculations/${id}/download_result_files_zip/${query ? `?${query}` : ''}`
      },
      DELETE_RESULT_FOLDER: (id: number, path = '') => {
        const params = new URLSearchParams()
        if (path) params.set('path', path)
        const query = params.toString()
        return `calculations/${id}/delete_result_folder/${query ? `?${query}` : ''}`
      },
      DOWNLOAD_ZIP_FILE: (id: number) => `calculations/${id}/download_zip_file/`,
      GET_CALCULATION_PROGRESS: (id: number) => `calculations/${id}/get_calculation_progress/`
    },
    HARDWARE_PROFILES: {
      INDEX: `hardware_profiles/`,
      HARDWARE_OPTIONS: `hardware_profiles/hardware_options/`
    }
  }
}

export default API
